import React from 'react';
import { Header } from './Header/Header';
import { Footer } from './Footer/Footer';
import { Outlet } from "react-router-dom";

const Layout = () => {
    return (
        <div className="layout">
            <Header />
            <main className="main-content mb-4"><Outlet /></main>
            <Footer />
        </div>
    );
};

export default Layout;
